import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PkCommonArrow from "../../../components/common/PkCommonArrow";
import { getLayoutText } from "../../../components/layout/getLayoutText";
import { getLayoutView } from "../../../components/layout/getLayoutView";
const Asset = require("../../../assets/meta.json");
export function Works() {
  return (
    <Box sx={{ backgroundColor: "white" }}>
      {getLayoutView(
        <>
          Frequently asked{" "}
          <span style={{ fontFamily: "Lato-Bold" }}>Questions</span>
        </>,
        [
          getLayoutText(
            <>
              Great talent is hard to find. We want to take the time to
              acknowledge a few exceptional people who have contributed to the
              development of the Polycaik platform.
            </>,
            { fontSize: "1.5rem", fontFamily: "Lato-Regular" }
          ),
        ],
        [12],
        {
          textAlign: "center",
          p: `8rem 10%`,
          "& .MuiTypography-root:not(.MuiTypography-caption)": {
            color: (theme) => theme.palette.grey[700],
          },
        }
      )}
      <PkCommonArrow color={`white`} />
      <Box
        sx={{
          p: `8rem 10%`,
          backgroundColor: (theme) => theme.palette.grey[800],
        }}
      >
        {Asset.question.map((m) => (
          <Accordion
            key={`${m.issue}`}
            sx={{ backgroundColor: `background.default` }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`${m.issue}-content`}
              id={`${m.issue}-id`}
            >
              <Typography variant={`h6`} color={`#eecb4d`}>
                {m.issue}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography fontFamily="Lato-Regular">{m.brief}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
}
